import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BreakdownsService } from 'src/app/services/http/breakdowns/breakdowns.service';

@Component({
  selector: 'app-extraction-year-breakdowns',
  templateUrl: './extraction-year-breakdowns.component.html',
  styleUrls: ['./extraction-year-breakdowns.component.scss']
})
export class ExtractionYearBreakdownsComponent implements OnInit {
  public loading: boolean = false;
  public data !: any;
  public list: any[] = [];
  public displayColumns : string[] = [];


  constructor(private service: BreakdownsService) { }

  ngOnInit(): void {
  }

  loadList(){
    this.loading = true;


    this.service.breakdownsOneYear().subscribe((data) => {
      this.data = data;
      this.displayColumns = Object.keys(data[0]);
      this.loading = false;
    })
  }

}
